import { selectGenerateContentLimits } from '~publish/legacy/ai/state/aiLimits/slice'
import { useAppSelector } from '~publish/legacy/store'

import styles from './UpgradeOptions.module.css'

import type { JSX } from 'react'

/**
 *
 */
const UpgradeOptions = (): JSX.Element => {
  const { generateContentTokensLeft } = useAppSelector((state) =>
    selectGenerateContentLimits(state),
  )

  return (
    <>
      <p className={styles.title}>
        {(generateContentTokensLeft ?? 0) > 0
          ? 'Get more AI Credits'
          : "You've used up all your AI Credits"}
      </p>
      <p className={styles.text}>Please reach out to Support to get more.</p>
    </>
  )
}

export { UpgradeOptions }
